import styled from 'styled-components';
import { Modal } from 'antd';

export const ModalContainer = styled(Modal)`
 
`;